import { Build } from "../products/types";

export const createRolloutTag = (rollout: number | undefined): API.Tag | null => {
    return rollout !== undefined && rollout !== 100
        ? {
            key: "rollout",
            value: String(rollout) + "%",
            type: "scoped",
        }
        : null;
};

export const createBuildVariantTag = (build: Build): API.Tag | null => {
    let variant = null;

    if (build.configOverride && "buildVariant" in build.configOverride) {
        variant = build.configOverride.buildVariant as string;
    } else if (build.configSnapshot && build.configSnapshot?.buildVariant) {
        variant = build.configSnapshot.buildVariant;
    }

    if (variant) {
        return {
            key: "variant",
            value: variant,
            type: "scoped",
        };
    }
    return null;
};
